<template>
  <div class="card modal-card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('popupEcritures.title') }}
          </h1>&nbsp;
          <h3>
            {{ libellePiece() }}
          </h3>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <div class="card-content">
        <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'remiseBancaire.errors.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
        <div v-for="ecriture in ecritures" :key="ecriture.id">
          <Ecriture :data="ecriture" />
        </div>
        <footer class="mgt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.close')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';
import { getByRemiseBancaire, getByFacture } from '@/api/compta/ifEcriture/index';
import { TYPE_VENTE } from '@/configuration/compta/ecritureConf';
import Ecriture from '@/components/commun/ecritureComptable/ecritureCompta';
import messageErreur from '@/services/general/messageErreur';
import getLibelleAvecCategorieProduit from '@/services/compteClient/getLibelleAvecCategorieProduit';
import { SENS_ACHAT } from '@/configuration/devisConf';

export default {
  name: 'popupEcritures',
  components: {
    Ecriture,
    errorMsgComponent,
  },
  props: {
    piece: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      ecritures: [],
    };
  },
  methods: {
    libellePiece() {
      if (this.piece === undefined || this.piece === null) return '';
      return this.getLibelleTypeDePiece() + ' ' + this.piece.reference + ' - '
        + getLibelleAvecCategorieProduit(this.piece);
    },
    getLibelleTypeDePiece() {
      const type = mouvementClientConf.LISTE_TYPE_PIECE_VENTE.find((type) => {
        return type.code === this.piece.typeDePiece;
      });
      return type ? this.$i18n.t(type.libelle) : '';
    },
    async loadEcritures() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        switch (this.piece.typeDePiece) {
          case mouvementClientConf.FACTURE:
          case mouvementClientConf.AVOIR:
          case mouvementClientConf.ACOMPTE:
            this.ecritures = (await getByFacture(this.piece.pieceId, TYPE_VENTE)).data.result;
            break;
          case mouvementClientConf.REGLEMENT:
            this.ecritures = (await getByRemiseBancaire(this.piece.pieceId, TYPE_VENTE))
              .data.result;
            break;
          case mouvementClientConf.CHARGE:
          case mouvementClientConf.AVOIR_DE_CHARGE:
            this.ecritures = (await getByFacture(this.piece.pieceId, SENS_ACHAT)).data.result;
            break;
          case mouvementClientConf.PAIEMENT:
            this.ecritures = (await getByRemiseBancaire(this.piece.pieceId, SENS_ACHAT))
              .data.result;
            break;
          default:
            break;
        }

        loadingComponent.close();
      } catch (error) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (error);
      }
    },
  },
  async mounted() {
    await this.loadEcritures();
  },
};
</script>

<style scoped>

</style>
